import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as string | null;

const slice = createSlice({
  name: '$bufferDeliveryTime',
  initialState,
  reducers: {
    setBufferDeliveryTime(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setBufferDeliveryTime } = slice.actions;
export default slice.reducer;
